module.exports = __webpack_public_path__ + "static/ss_web_hero_2024-51e8139388fb49eb34ee841be37fd732.mp4";